const planet = {
  state: {
    planet: null,
    member: null,
    updateMethod: "refresh",
  },
  mutations: {
    setPlanet(state, payload) {
      state.planet = payload.planet;
    },
    setMember(state, payload) {
      state.member = payload.member;
    },
    setUpdateMethod(state, payload) {
      state.updateMethod = payload.updateMethod;
    },
  },
};

export default planet;
